<div class="h-100 box d-flex flex-column px-2 pb-5 relative">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-episode-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div class="py-4 px-4 relative inner h-100">
            <div class="text-s font-semi-bold mb-4">{{ 'v3-byoc-popup-create-episode-position-title' | translate }}</div>

            <div class="border border-dark rounded relative p-4">
                <ng-container *ngIf="loaded">
                    <div class="d-flex align-items-center mb-4">
                        <div ariaHidden class="icon icon-l icon-default me-4" inlineSVG="assets/icons.svg#stack"></div>
                        <div class="text-s font-bold text-uppercase me-auto">{{ course.name }}</div>
                        <a
                            *ngIf="course.status === 2 && course.stats?.episodes?.total !== 0"
                            [routerLink]="['/library', 'course', course.id]"
                            [target]="'_blank'"
                            class="inline ms-4"
                            [ngbTooltip]="'v3-global-view-full-course' | translate"
                            container="body"
                            linkDataTest="courseLink"
                        >
                            <div class="icon icon-l icon-default" inlineSVG="assets/icons.svg#open-external"></div>
                        </a>
                    </div>

                    <div class="ps-6">
                        <app-byoc-episode-step-position-list (loadedList)="listLoaded($event)" [course]="course"></app-byoc-episode-step-position-list>
                    </div>
                </ng-container>

                <div *ngIf="!loaded" class="py-6">
                    <app-loader loaderType="cover" overlayColor="white"></app-loader>
                </div>
            </div>
        </div>
    </div>

    <div class="theme-new d-flex align-items-stretch buttons-container flex-sm-row flex-column justify-content-center px-4">
        <button (click)="cancelClick()" class="btn btn-primary ms-sm-auto text-wrap" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button (click)="backClick()" class="btn btn-primary text-wrap" buttonDataTest="backButton" translate>v3-button-back</button>
        <button
            (click)="saveAsDraftClick()"
            class="btn text-wrap"
            [ngClass]="[loaded && loadedList ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="saveAsDraftButton"
            translate
        >
            v3-button-save-as-draft
        </button>
        <button
            (click)="usersClick()"
            class="btn text-wrap"
            [ngClass]="[loaded && loadedList ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="publishButton"
            translate
        >
            v3-button-publish
        </button>
    </div>

    <app-loader *ngIf="saving" loaderType="cover" overlayColor="white"></app-loader>
</div>
